import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { withUIETheme } from '../uietheme/withUIETheme';
const ContentHeading = ({ children, uieTheme }) => {
    const style = {
        fontSize: uieTheme.fontSizes.veryBig,
        backgroundColor: uieTheme.colors.bgContentHeading,
        color: uieTheme.colors.textMainHeading,
        lineHeight: 1,
        paddingLeft: uieTheme.colors.bgContentHeading === 'transparent' ? 0 : uieTheme.spacing.space2,
        paddingRight: uieTheme.spacing.space2,
        paddingBottom: uieTheme.spacing.space2,
        paddingTop: uieTheme.spacing.space2,
        textTransform: 'uppercase',
        margin: 0,
        marginBottom: uieTheme.spacing.space0,
    };
    return (React.createElement(FelaComponent, { style: [style, uieTheme.fontStyles.headline], as: "h2" }, children));
};
export default withUIETheme(ContentHeading);
//# sourceMappingURL=ContentHeading.js.map